module.exports = __webpack_public_path__ + "img/LogoDashboard-14.0c0a5866.svg";